module.exports = __webpack_public_path__ + "static/media/7.2.bd97e3a9.png";